<template>
  <PagesArchiveComponent
    :pageData="data"
  />
</template>

<script setup>
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryArchivePage() } }
  )
})

if (!data?.value?.data?.id || error?.value) {
  throw createError({ statusCode: 404 })
}

pageSetHead(data)
</script>
